import { DayPicker } from 'react-day-picker';
import classNames from '@/lib/classNames';
import { Icon } from '../../global/Icons';
import { buttonVariants } from '../Button';

export type CalendarProps = React.ComponentProps<typeof DayPicker> & {
    monthToShow?: Date;
};

function Calendar({ className, showOutsideDays = true, monthToShow, ...props }: CalendarProps) {
    return (
        <DayPicker
            defaultMonth={monthToShow}
            showOutsideDays={showOutsideDays}
            className={classNames('p-3', className)}
            classNames={{
                months: 'flex flex-col sm:flex-row space-y-4 sm:space-x-4 sm:space-y-0',
                month: 'space-y-4',
                caption: 'flex justify-center pt-1 relative items-center',
                caption_label: 'text-sm font-medium',
                nav: 'space-x-1 flex items-center',
                nav_button: classNames(buttonVariants({ variant: 'outline' }), 'h-7 w-7 bg-transparent p-0 opacity-50 hover:opacity-100'),
                nav_button_previous: 'absolute left-1',
                nav_button_next: 'absolute right-1',
                table: 'w-full border-collapse space-y-1',
                head_row: 'flex',
                head_cell: 'font-light rounded-md w-9 font-normal text-[0.8rem]',
                row: 'flex w-full mt-2',
                cell: 'text-center text-sm p-0 relative [&:has([aria-selected])]:bg-rock first:[&:has([aria-selected])]:rounded-l-md last:[&:has([aria-selected])]:rounded-r-md focus-within:relative focus-within:z-20',
                day: classNames(buttonVariants({ variant: 'ghost' }), 'h-9 w-9 p-0 font-normal aria-selected:opacity-100 rounded-md'),
                day_selected: 'bg-primary text-white hover:bg-primary/50 hover:text-white focus:bg-primary focus:text-white',
                day_outside: 'font-light opacity-50',
                day_disabled: 'font-light opacity-50',
                day_range_middle: 'aria-selected:bg-rock aria-selected:text-primary',
                day_hidden: 'invisible',
                ...props.classNames,
            }}
            components={{
                IconLeft: () => <Icon id="chevron-left" className="w-4 h-4 fill-primary" />,
                IconRight: () => <Icon id="chevron-right" className="w-4 h-4 fill-primary" />,
            }}
            {...props}
        />
    );
}
Calendar.displayName = 'Calendar';

export { Calendar };
